import {nsUtils} from "./nsUtils";
import {moment} from 'moment';

export namespace nsDate {

    const ServerDateFormats: string[] = [
        'DD.MM.YYYY HH:mm A', // API weirdness
        'DD.MM.YYYY HH:mm:ss A', // API weirdness
        'DD.MM.YYYY hh:mm A', // API weirdness
        'DD.MM.YYYY HH:mm',
        'DD.MM.YYYY HH:mm:ss',
        'DD.MM.YYYY hh:mm',
        'DD.MM.YYYY',
        'M/D/YYYY h:mm:ss A',
        'MM/DD/YYYY hh:mm:ss A',
        'MM/DD/YYYY hh:mm:ss A',
        'YYYY-MM-DD',
        'YYYY-MM-DDTHH:mm:ss',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSSSS',
    ].reduce((arr: string[], str: string) => arr.concat([str, str + 'Z']), []);

    export function convertFromServerString(str: string): moment.Moment {
        const m: moment.Moment = moment(str, ServerDateFormats);
        if (!nsUtils.isNullOrUndefined(str)) {
            // todo
            console.assert(m.isValid(), m)
        }
        if (m.isValid()) {
            // jolly good
            return m;
        }

        // todo
        console.warn("Date string doesn't conform to any known date format. Using new Date() instead.", str);
        return moment(new Date(str));
    }

    export function convertToServerString(m: moment.Moment, addSeconds = false): string {
        if (m.isValid()) {
            let ret = m.format("DD.MM.YYYY HH:mm");
            if (addSeconds) {
                ret += ':00';
            }
            return ret;
        } else {
            return '';
        }
    }

    export function getDate(str: string, full: boolean): string {
        let m = convertFromServerString(str);
        if (full) {
            return m.format('L');
        } else {
            const longFormat = moment.localeData().longDateFormat('L')
            const shortFormat = longFormat.replace(/(.YYYY)/gm, '');
            return m.format(shortFormat);
        }
    }

    export function getNextWorkDay(m: moment.Moment = moment()) {
        m.startOf('day').add(1, 'day')
        // skip weekend (saturday and sunday)
        while (m.isoWeekday() == 6 || m.isoWeekday() == 7) {
            m.add(1, 'day')
        }
        return m
    }

    export const MinDate = 1;
    export const MaxDate = 30;

    export function getMinDate(): moment.Moment {
        return moment().add(MinDate, 'day').startOf('day');
    }

    export function getMaxDate(): moment.Moment {
        return moment().add(MaxDate, 'day').endOf('day');
    }

}